import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const team = [
  {
    name: 'Nzambu Joseph',
    role: 'Founder & Lead Developer',
    bio: 'Full-stack architect with 5+ years building systems for startups and enterprises across East Africa.',
    initials: 'NJ',
    color: 'fire',
  },
  {
    name: 'Sensei',
    role: 'UI/UX Lead',
    bio: 'Human-centered designer obsessed with turning complexity into elegance. 200+ interfaces shipped.',
    initials: 'S',
    color: 'ice',
  },
  {
    name: 'Mwangi',
    role: 'Mobile Developer',
    bio: 'React Native and Flutter specialist. If it runs on a phone, Brian can build it — beautifully.',
    initials: 'M',
    color: 'fire',
  },
  {
    name: 'Nyambura',
    role: 'Systems Architect',
    bio: 'Database and backend mastermind. Built ERPs that handle millions of records without breaking a sweat.',
    initials: 'N',
    color: 'ice',
  },
];

const values = [
  { icon: '🎯', title: 'Precision', desc: 'We don\'t guess. Every decision is deliberate, data-informed, and targeted.' },
  { icon: '⚡', title: 'Speed', desc: 'Fast execution without sacrificing quality. We move like startups, build like enterprises.' },
  { icon: '🔒', title: 'Reliability', desc: 'What we commit to, we deliver. On time, on spec, no excuses.' },
  { icon: '🚀', title: 'Innovation', desc: 'We stay ahead of the curve so your product is never behind the times.' },
  { icon: '🤝', title: 'Partnership', desc: 'We\'re not just vendors — we\'re invested in your long-term success.' },
  { icon: '🌍', title: 'Africa-First', desc: 'Built in Kenya, thinking globally. We understand the African market inside out.' },
];

export default function About() {
  return (
    <main className="about-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero__glow" />
        <div className="container page-hero__inner">
          <div className="section-header__tag">Our Story</div>
          <h1 className="page-hero__title">
            Born in Kenya.<br/>
            <span className="text-fire">Built for the World.</span>
          </h1>
          <p className="page-hero__desc">
            LaserGuided Solutions started with a simple belief: African businesses deserve
            world-class technology — precise, powerful, and purpose-built.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="mission-section">
        <div className="container mission-inner">
          <div className="mission-left">
            <div className="section-header__tag" style={{textAlign:'left'}}>Our Mission</div>
            <h2 className="mission-title">
              Technology that <span className="text-fire">Hits</span> <br/>
              Where it Matters
            </h2>
            <p className="mission-desc">
              We founded LaserGuided Solutions with the conviction that precision-built technology
              can transform businesses. Our mission is to deliver digital solutions so accurate,
              so reliable, and so powerful that our clients achieve outcomes they couldn't imagine before.
            </p>
            <p className="mission-desc">
              Every line of code we write, every system we architect, every app we ship — it's
              all guided by one question: <em>does this hit the target?</em>
            </p>
            <blockquote className="mission-quote">
              <em>"Target your success with accuracy"</em>
            </blockquote>
          </div>
          <div className="mission-right">
            <div className="mission-card">
              <div className="mission-card__glow" />
              <div className="mission-card__stat">
                <div className="mission-card__num">2026</div>
                <div className="mission-card__label">Founded in Kenya</div>
              </div>
              <div className="mission-card__divider" />
              <div className="mission-card__stat">
                <div className="mission-card__num">50+</div>
                <div className="mission-card__label">Projects Delivered</div>
              </div>
              <div className="mission-card__divider" />
              <div className="mission-card__stat">
                <div className="mission-card__num">8+</div>
                <div className="mission-card__label">Countries Served</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <div className="section-header__tag">What Drives Us</div>
            <h2 className="section-header__title">Our Core <span className="text-ice">Values</span></h2>
          </div>
          <div className="values-grid">
            {values.map((v, i) => (
              <div key={i} className="value-card">
                <div className="value-card__icon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <div className="section-header__tag">The Team</div>
            <h2 className="section-header__title">The Minds Behind <span className="text-fire">the Laser</span></h2>
            <p className="section-header__sub">
              A tight-knit squad of builders, designers, and strategists who obsess over craft.
            </p>
          </div>
          <div className="team-grid">
            {team.map((member, i) => (
              <div key={i} className={`team-card team-card--${member.color}`}>
                <div className={`team-card__avatar team-card__avatar--${member.color}`}>
                  {member.initials}
                </div>
                <h3 className="team-card__name">{member.name}</h3>
                <div className="team-card__role">{member.role}</div>
                <p className="team-card__bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-banner">
        <div className="cta-banner__glow" />
        <div className="container cta-banner__inner">
          <div>
            <h2 className="cta-banner__title">Want to Join the Team?</h2>
            <p className="cta-banner__sub">We're always looking for sharp minds. Reach out.</p>
          </div>
          <div className="cta-banner__actions">
            <Link to="/contact" className="btn btn--white">Get In Touch →</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
